import * as moment from 'moment';
import {Utils} from './Utils';
import {EmployeeTimesheetAggregation} from './timesheet.model';

import {EmployeeHoraire} from "./EmployeHoraire";

export class TimesheetManager {

  private distinctApproverName = new Array<string>();
  private timesheetManagersByEmployeeId = new Map<string, EmployeeTimesheetAggregation[]>();
  private timesheetManagersToApproveByDate = new Map<string, EmployeeTimesheetAggregation[]>();

  private allEmployeeTimesheetAggregation = new Array<EmployeeTimesheetAggregation>();
  private timesheetToApproveByDate = new Map<string, EmployeeHoraire[]>();
  private timesheetsAggregationByDateAndEmployeeId = new Map<string, EmployeeTimesheetAggregation>();

  public add(bean: EmployeeTimesheetAggregation) {
    if (!bean.employe) {
      console.log('No employee information found for EmployeeTimesheetAggregation');
      return;
    }
    // this.timesheetManagersByEmployeeId.set(bean.employe.id, bean);
    if (!this.timesheetManagersByEmployeeId.get(bean.employe.id)) {
      this.timesheetManagersByEmployeeId.set(bean.employe.id, new Array<EmployeeTimesheetAggregation>());
      this.allEmployeeTimesheetAggregation.push(bean);
    }
    this.timesheetManagersByEmployeeId.get(bean.employe.id).push(bean);

    for (const eh of bean.timesheets) {
      if (eh.tsApprovedByFullName && eh.tsApprovedByFullName.length > 0 && this.distinctApproverName.indexOf(eh.tsApprovedByFullName) == -1) {
        this.distinctApproverName.push(eh.tsApprovedByFullName);
      }
    }

    if (bean.toApprove > 0 ) {
      for (const eh of bean.timesheets){
        if (eh.tsApproved) {
          continue;
        }
        const dt = Utils.createKeyForDate(eh.refDate);
        // const key = dt + '.' + bean.employe.id;
        const key = Utils.createKeyDateAndEmployeeId(eh.refDate,bean.employe.id);
        if (!this.timesheetsAggregationByDateAndEmployeeId.get(key)){
          if (!this.timesheetManagersToApproveByDate.get(dt)) {
            this.timesheetManagersToApproveByDate.set(dt, new Array<EmployeeTimesheetAggregation>());
          }
          this.timesheetManagersToApproveByDate.get(dt).push(bean);
          this.timesheetsAggregationByDateAndEmployeeId.set(key,bean);
        }

        if (!this.timesheetToApproveByDate.get(dt)){
          this.timesheetToApproveByDate.set(dt, new Array<EmployeeHoraire>());
        }
//        console.log('Adding for key: ' + dt + ',  ' + bean.employe.fullName + ' id timesheets: ' + eh.id);
        this.timesheetToApproveByDate.get(dt).push(eh);
      }
    }
  }

  public clear() {
     this.allEmployeeTimesheetAggregation = new Array<EmployeeTimesheetAggregation>();
     this.timesheetManagersToApproveByDate.clear();
     this.timesheetManagersByEmployeeId.clear();
     this.timesheetsAggregationByDateAndEmployeeId.clear();
     this.timesheetToApproveByDate.clear();
  }

  public remove(employeHoraireId: number, employeeId: string){
    if (!Utils.isNullOrUndefined(employeHoraireId) && !Utils.isNullOrUndefined(employeeId)) {
      let dateRef;


      for (const bean of this.allEmployeeTimesheetAggregation) {
        if (bean.employe.id === employeeId){
          let tmp = this._removeLine(bean, employeHoraireId);
          if (!Utils.isNullOrUndefined(tmp)) {
            dateRef = tmp;
            employeeId = bean.employe.id;
            break;
          }
        }
      }
      this._removeTimesheetManagersToApproveByDate(dateRef, employeeId, employeHoraireId)
      this._removeTimesheetManagersByEmployeeId(employeeId, employeHoraireId);
      this._removeTimesheetsAggregationByDateAndEmployeeId(dateRef, employeeId, employeHoraireId);
      this._removeTimesheetToApproveByDate(dateRef, employeeId, employeHoraireId);
    }
  }



  private _removeLine(bean: EmployeeTimesheetAggregation, employeHoraireId: number):string{
    let dateRef:string;
    if (!Utils.isNullOrUndefined(employeHoraireId)){
      let lineToRemove = -1;
      for (let idx = 0; idx < bean.timesheets.length; idx ++) {
        if (employeHoraireId === bean.timesheets[idx].id) {
          lineToRemove = idx;
          dateRef = Utils.createKeyForDate(bean.timesheets[idx].refDate);
          break;
        }
      }
      if (lineToRemove >= 0) {
        bean.timesheets.splice(lineToRemove, 1 );
        // employeeId = bean.employe.id;
      }
    }
    return dateRef;
  }

  private _removeTimesheetManagersToApproveByDate(dtRef: string, employeeId: string, employeHoraireId: number){
    if (!Utils.isNullOrUndefined(dtRef) && !Utils.isNullOrUndefined(employeeId) && !Utils.isNullOrUndefined(employeHoraireId)){

      if (this.timesheetManagersToApproveByDate.has(dtRef)) {
        for (const bean of this.timesheetManagersToApproveByDate.get(dtRef) ){
          if (bean.employe.id === employeeId){

            const tmp = this._removeLine(bean,employeHoraireId);
            if (!Utils.isNullOrUndefined(tmp)){
              break;
            }
            /*
            let lineToRemove = -1;
            for (let idx = 0; idx < bean.timesheets.length; idx ++) {
              if (employeHoraireId === bean.timesheets[idx].id) {
                lineToRemove = idx;
                break;
              }
            }

             */
          }
        }
      }
    }
  }



  private _removeTimesheetManagersByEmployeeId(employeeId: string, employeHoraireId: number){
    if (!Utils.isNullOrUndefined(employeeId) && !Utils.isNullOrUndefined(employeHoraireId)){

      if (this.timesheetManagersByEmployeeId.has(employeeId)) {
        for (const bean of this.timesheetManagersByEmployeeId.get(employeeId) ){
          const tmp = this._removeLine(bean,employeHoraireId);
          if (!Utils.isNullOrUndefined(tmp)){
            break;
          }
        }
      }
    }
  }


  private _removeTimesheetsAggregationByDateAndEmployeeId(dtRef: string, employeeId: string, employeHoraireId: number){
    if (!Utils.isNullOrUndefined(dtRef) && !Utils.isNullOrUndefined(employeeId) && !Utils.isNullOrUndefined(employeHoraireId)){

      const key = dtRef + "." + employeeId;

      if (this.timesheetsAggregationByDateAndEmployeeId.has(key)) {
       const tmp = this._removeLine( this.timesheetsAggregationByDateAndEmployeeId.get(key),employeHoraireId);
      }
    }
  }


  private _removeTimesheetToApproveByDate(dtRef: string, employeeId: string, employeHoraireId: number){
    if (!Utils.isNullOrUndefined(dtRef) && !Utils.isNullOrUndefined(employeeId) && !Utils.isNullOrUndefined(employeHoraireId)){

      if (this.timesheetToApproveByDate.has(dtRef)) {
            let lineToRemove = -1;
            for (let idx = 0; idx < this.timesheetToApproveByDate.get(dtRef).length; idx ++) {
              if (employeHoraireId === this.timesheetToApproveByDate.get(dtRef)[idx].id) {
                lineToRemove = idx;
                break;
              }
            }

            if (lineToRemove >= 0) {
              this.timesheetToApproveByDate.get(dtRef).splice(lineToRemove, 1 );
              // employeeId = bean.employe.id;
            }


      }
    }
  }




  public get(key: string): EmployeeTimesheetAggregation[] {
    // console.log('getting >' + key + '<');
    const res = this.timesheetManagersByEmployeeId.get(key);
    return res;
  }

  get keys(): string[] {
    return Array.from(this.timesheetManagersByEmployeeId.keys());
  }

  get keyOrderedByDates(): string[]{
    const res = Array.from(this.timesheetManagersToApproveByDate.keys());
    res.sort( (a: string, b: string) =>  {
      let resN = 0;
      if (a > b) {
        resN = 1;
      }
      if (a < b) {
        resN = -1;
      }
      return resN;
    });
    return res;
  }

  public orderByEmployee(toOrder: EmployeeTimesheetAggregation[]): EmployeeTimesheetAggregation[]{
    const res = new Array<EmployeeTimesheetAggregation>();
    res.push(...toOrder);
    res.sort( (a: EmployeeTimesheetAggregation, b: EmployeeTimesheetAggregation) => {

      let resN = 0;
      if (a.employe.fullName > b.employe.fullName) {
        resN = 1;
      }
      if (a.employe.fullName < b.employe.fullName) {
        resN = -1;
      }
      return resN;

    });
    return res;
  }


  public sortEmployees(): EmployeeTimesheetAggregation[] {
    this.allEmployeeTimesheetAggregation.sort( (a: EmployeeTimesheetAggregation, b: EmployeeTimesheetAggregation) => {
      let resN = 0;
      if (a.employe.fullName > b.employe.fullName) {
        resN = 1;
      }
      if (a.employe.fullName < b.employe.fullName) {
        resN = -1;
      }
      return resN;

    });
    return this.allEmployeeTimesheetAggregation;
  }


  public approvers(): string[] {
    this.distinctApproverName.sort();
    return this.distinctApproverName;
  }


  public getByDate(key: string): EmployeeTimesheetAggregation[] {
    const res = this.timesheetManagersToApproveByDate.get(key);
    if (!res) {
      return new Array<EmployeeTimesheetAggregation>();
    }

    return res;
  }

  public keysInDateRange(from: Date, to: Date): string[] {
    const res = new Array<string>();
    const stMoment = moment(from);
    const end = moment(to);

     while (true) {

       const dt = stMoment.format('YYYYMMDD');
       const ts = this.getByDate(dt);
       if (ts && ts.length > 0 ) {
         res.push(dt);
       }

       if (end.isSame(stMoment, 'day')) {
         break;
       }
       stMoment.add(1, 'day');
     }
    return res;
  }


  public getTimesheetsToApproveByDateAndEmployeeId(key: string, employeeId: string): EmployeeHoraire[]{
    const tmp = this.timesheetToApproveByDate.get(key);
    if (!tmp) {
      return new Array<EmployeeHoraire>();
    }else{
      const res = new Array<EmployeeHoraire>();
      for (const bean of tmp){
        if (bean.employeeId === employeeId){
          res.push(bean);
        }
      }
      return res;
    }
  }


  public getTimesheetsToApproveByDate(key: string): EmployeeHoraire[]{
    const res = this.timesheetToApproveByDate.get(key);
    if (!res) {
      return new Array<EmployeeHoraire>();
    }
    /*res.sort( (a: EmployeeHoraire, b: EmployeeHoraire) => {
      let resN = 0;
      if (a.employe.fullName > b.employe.fullName) {
        resN = 1;
      }
      if (a.employe.fullName < b.employe.fullName) {
        resN = -1;
      }
      return resN;

    });
    */
    return res;
  }


}
